<template>
  <div
    :class="['radio', checked ? 'checked' : 'no-checked', disabled && 'disable-checked']" @click='changeRadio'
  ></div>
</template>

<script>
  export default {
    name: 'radio',
    props: {
      message: String,
      checked: {
        type: Boolean,
        default: () => false
      },
      disabled: {
        type: Boolean
      }
    },
    data () {
      return {
      }
    },
    watch: {},
    computed: {},
    created () {

    },
    mounted () {
    },
    methods: {
      changeRadio(){
        if(this.disabled == true){
          return false;
        }else{
          this.$emit('changeRadio')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .radio{
    width: 32px;
    height: 32px;
    &.checked{
      background: url("/images/public/checked.png") no-repeat center;
      background-size: cover
    }
    &.no-checked{
      background: url("/images/public/no-checked.png") no-repeat center;
      background-size: cover
    }
    &.disable-checked{
      background: url("/images/public/disable-checked.png") no-repeat center;
      background-size: cover
    }
  }
</style>
